import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'common/utils/browserHistory';
import DateOfBirth from 'common/display/DateOfBirth';
import { Form } from 'react-final-form';
import { Button } from '@unite-us/app-components';
import { getEnumsFromState } from 'common/utils/Enums';
import { hasLimitedGenderOptions } from 'common/utils/FeatureFlags/flags';
import Header from './Header';
import ContactDetailReviewDemographic from './ContactDetailReviewDemographic';
import ContactDataAsDisplay from './ContactDataAsDisplay';
import '../stylesheets/contactStepper.scss';

class ContactDetailReview extends Component {
  constructor(props) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
    this.complete = this.complete.bind(this);
    this.restartContactForm = this.restartContactForm.bind(this);
  }

  onSubmit() {
    this.complete();
  }

  complete() {
    this.props.onComplete();
  }

  restartContactForm() {
    if (this.props.onGoBack) {
      return this.props.onGoBack();
    }
    return browserHistory.push('/contacts/new/search');
  }

  render() {
    const {
      contact,
      header,
      mainHeader,
      subHeader,
      enums,
      initialValues,
      limitedGenderOptions,
    } = this.props;

    return (
      <Form onSubmit={this.onSubmit} initialValues={initialValues}>
        {({ handleSubmit, submitting, values }) => (
          <form
            className="contact-details-review"
            onSubmit={handleSubmit}
          >
            <Header
              header={header}
              mainHeader={mainHeader}
              subHeader={subHeader}
            />

            <div className="confirmed-details">
              <div className="confirmed-details__wrapper">
                <div className="confirmed-details__name confirmed-details__row">
                  <span className="strong">Name: </span>
                  <span> {contact.full_name}</span>
                </div>

                {
                  contact.date_of_birth && (
                    <div className="confirmed-details__dob confirmed-details__row">
                      <span className="strong">Date of Birth</span>
                      <div>
                        <DateOfBirth date={contact.date_of_birth} />
                      </div>
                    </div>
                  )
                }

                <div className="confirmed-details__contact-data confirmed-details__row">
                  <ContactDataAsDisplay values={values} />
                </div>

                <ContactDetailReviewDemographic
                  enums={enums}
                  values={values}
                  limitedGenderOptions={limitedGenderOptions}
                />
              </div>
            </div>

            <footer className="referral-footer">
              <Button
                id="go-back-btn"
                onClick={this.restartContactForm}
                label="Go Back"
                style={{ marginRight: '10px' }}
              />
              <Button
                id="save-and-continue-btn"
                onClick={handleSubmit}
                label="Save and Continue"
                disabled={submitting}
                style={{ float: 'right' }}
                primary
              />
            </footer>
          </form>
        )}
      </Form>
    );
  }
}

ContactDetailReview.propTypes = {
  contact: PropTypes.object.isRequired,
  enums: PropTypes.object,
  initialValues: PropTypes.object,
  header: PropTypes.string.isRequired,
  mainHeader: PropTypes.string,
  onComplete: PropTypes.func.isRequired,
  onGoBack: PropTypes.func,
  subHeader: PropTypes.string.isRequired,
  limitedGenderOptions: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
  const { selectedContact, session: { groupId } } = state;
  const allContacts = state.searchedContacts.concat(state.contacts.contacts);
  const contact = allContacts
    .find((person) => person.id === selectedContact);
  return {
    groupId,
    selectedContact,
    contact,
    enums: getEnumsFromState(state),
    initialValues: {
      email: (contact.email_addresses.find((email) => email.is_primary) || {}).email_address,
      phone: (contact.phone_numbers.find((phone) => phone.is_primary) || {}).phone_number,
      phone_type: (contact.phone_numbers.find((phone) => phone.is_primary) || {}).phone_type,
      gender: contact.gender,
      marital_status: contact.marital_status,
      race: contact.race,
      ethnicity: contact.ethnicity,
    },
    limitedGenderOptions: hasLimitedGenderOptions(state),
  };
}

export default connect(mapStateToProps)(ContactDetailReview);
